import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import apiClient from '../../lib/api-client';

import { myAdvisorsKey } from './useMyAdvisors';

export interface AdminManagedTeam {
  salesTeamId: string;
  salesTeamName: string;
  policyCount: number;
  policyIdPreview: string[];
  assignedEmails: string[];
}

export interface AdminManagedTeamsResponse {
  teams: AdminManagedTeam[];
  summary: {
    teamCount: number;
    policyCount: number;
    assignedEmailCount: number;
  };
}

export interface UpdateAdminManagedTeam {
  salesTeamId: string;
  emails: string[];
}

export const adminTeamMappingsKey = ['admin', 'vp-team-mappings'] as const;

async function fetchAdminTeamMappings(): Promise<AdminManagedTeamsResponse> {
  const response = await apiClient.get<AdminManagedTeamsResponse>('/admin/vp-team-mappings');
  return response.data;
}

async function saveAdminTeamMappings(
  teams: UpdateAdminManagedTeam[]
): Promise<AdminManagedTeamsResponse> {
  const response = await apiClient.put<AdminManagedTeamsResponse>('/admin/vp-team-mappings', {
    teams,
  });
  return response.data;
}

export function useAdminTeamMappings() {
  return useQuery({
    queryKey: adminTeamMappingsKey,
    queryFn: fetchAdminTeamMappings,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

export function useSaveAdminTeamMappings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveAdminTeamMappings,
    onSuccess: (data) => {
      queryClient.setQueryData(adminTeamMappingsKey, data);
      queryClient.invalidateQueries({ queryKey: myAdvisorsKey });
    },
  });
}
